import { cn } from '@/lib/utils';
import { PageShellContext } from './context';
import { PageShellProps } from './types';

const PageShell = (props: PageShellProps) => {
  const {
    children,
    className,
    contentVariant = 'face',
    footerMode = 'static',
    headerMode = 'static'
  } = props;

  return (
    <PageShellContext.Provider
      value={{
        contentVariant,
        footerMode,
        headerMode
      }}
    >
      <div className={cn('relative flex min-h-screen w-full flex-col', className)}>
        {children}
      </div>
    </PageShellContext.Provider>
  );
};

export default PageShell;